export default {
    translation: {
        title: "아메리카",
        applications: "애플리케이션",
        full_text: "전체 텍스트",
        vehicle: {
            status: "{{direction}} 방향으로 시속 {{speed}}마일로 주행 중"
        },
        talkie: {
            drivers_nearby_singular: "근처에 운전자가 1명 있습니다",
            drivers_nearby_plural: "근처에 운전자가 {{count}}명 있습니다"
        },
        settings: {
            save_progress_description:
                "백업이나 다른 컴퓨터로 이동하기 위해 플로피 디스크에 진행 상황을 저장하세요.",
            save_progress_action: "진행 상황 저장",
            load_progress_action: "진행 상황 불러오기...",
            display_units: "표시 단위",
            imperial: "야드파운드법",
            metric: "미터법",
            start_over_description:
                "여행을 조기에 종료합니다. 현재 진행 상황이 삭제됩니다. 이 작업은 취소할 수 없습니다.",
            start_over_action: "처음부터 시작"
        },
        feedback: {
            message: "메시지",
            contact_info: "연락처 (선택사항)",
            send: "보내기",
            sending: "보내는 중..."
        },
        radio: {
            no_reception: "이 지역에서는 라디오를 수신할 수 없습니다",
            low_signal: "신호가 약합니다",
            turn_off: "전원 끄기",
            turn_on: "전원 켜기",
            next_station: "다음 방송국",
            unmute: "음소거 해제",
            mute: "음소거"
        },
        photos: {
            source: "Mapillary 제공",
            empty: "사진을 찍기 위해 주변을 탐색 중..."
        },
        news: {
            loading: "현지 뉴스를 확인 중...",
            nothing_found: "찾을 수 없습니다."
        },
        metrics: {
            duration_title: "운전 시간",
            duration_value: "{{days}}일 {{hours}}시간 {{minutes}}분",
            distance_title: "이동 거리",
            emissions_title: "배출 가스 CO2",
            emissions_value_g: "{{g}}g",
            emissions_value_kg: "{{kg}}kg",
            states_visited_title: "방문한 주",
            cairns_discovered_title: "발견된 케인",
            exploration_title: "탐험"
        },
        compass: {
            north_east: "북동",
            east: "동",
            south_east: "남동",
            south: "남",
            south_west: "남서",
            west: "서",
            north_west: "북서",
            north: "북"
        },
        landing: {
            about_title: "소개",
            start_title: "시작",
            features_title: "특징",
            about_headline: "아메리카: 브라우저에서 즐기는 로드트립 시뮬레이터",
            about_paragraph_1:
                "Safari, Chrome, Edge. 이들은 웹의 무한한 구석으로 가는 관문입니다.\n"
                + "아메리카는 또 다른 종류의 광활한 지형으로 가는 당신의 관문입니다: 미국\n"
                + "합중국 자연의 경이. 당신만의 속도로 배울 것이 많습니다.",
            about_paragraph_2:
                "장엄한 풍경부터 조용한 길가의 순간까지, 데스크톱 스타일의 창 인터페이스로\n"
                + "여행을 조종합니다: 지도, 라이브 라디오, 백과사전 기사, 카메라 롤, 지표,\n"
                + "저널 등. 점수판 없음, 서두르지 않음: 우연한 발견과 분위기가 최우선.\n"
                + "최신 브라우저에서 열면 설치 없이 바로 시작할 수 있습니다.",
            about_paragraph_3:
            "여행 경로는 자유입니다. 퍼시픽 코스트 하이웨이, 평원을 가로지르는 루트 66,"
                + "로키산맥을 지나 국립공원으로, 뉴잉글랜드의 시골길까지. 멈출 때마다 그 장소의"
                + "이야기가 열립니다: 이 마을, 협곡, 전망대가 무엇을 보아왔는지, 라디오에서 무엇이"
                + "흐르는지, 지금 날씨가 어떤지. 자신의 속도로 미국을 탐험하는 브라우저 기반"
                + "로드트립 시뮬레이터입니다.",

            trips_title: "여행으로 탐색",
            trips_list: [
                { label: "가상 로드트립", url: "/virtual-road-trip/" },
                { label: "미국 로드트립", url: "/us-road-trip/" },
                { label: "국립공원 로드트립", url: "/national-parks-road-trip/" },
                { label: "루트 66 로드트립", url: "/route-66-road-trip/" },
                { label: "미국 탐험", url: "/explore-america/" },
                { label: "미국 횡단 로드트립", url: "/road-trip-across-america/" }
            ],
            watch_commercial: "광고 보기",
            start_cta: "여행 시작",
            start_cta_lead: "설치 불필요. 브라우저에서 실행됩니다.",
            features_lede:
                "여행이 시작되면 아메리카의 로드트립 스위트에서 대시보드를 구성합니다.\n"
                + "각 창은 국가를 경험하는 서로 다른 방법입니다. 현지 라디오부터 다른\n"
                + "운전자들과의 트랜시버까지, 매 여행마다 새로운 것을 발견하게 될 것입니다.",
            features_list: [
                "미국 전역의 라우팅과 탐험이 가능한 지도",
                "스트리밍 라디오와 장소 기반 기사 및 사진",
                "저널, 지표, 카메라 롤, 백과사전",
                "친구, 음성 채팅, 공유된 길가 랜드마크(케인)",
                "전화나 데스크톱에서 브라우저로 실행; 다운로드 불필요"
            ],
            media_alt: "아메리카 컴플리트 에디션: 소프트웨어 박스 및 CD",
            slideshow_alt: "아메리카 시뮬레이터의 로드트립 풍경 사진, 이미지",
            og_title: "아메리카: 로드트립 시뮬레이터",
            og_description:
                "데스크톱 스타일의 재미있는 로드트립 시뮬레이터로 미국 합중국의 자연 경이를 탐색하세요. 지도, 라디오, 저널, 그리고 우연한 발견이 브라우저에서 바로 제공됩니다.",
            twitter_description:
                "데스크톱 스타일의 재미있는 로드트립 시뮬레이터로 미국 합중국의 자연 경이를 탐색하세요. 설치 불필요.",
            meta_description:
                "아메리카는 브라우저용 로드트립 시뮬레이터입니다: 지도, 라디오, 사진, 데스크톱 스타일 인터페이스로 미국 자연의 경이를 자신만의 속도로 탐색. 다운로드 불필요; 온라인으로 여행을 시작하세요.",
            jsonld_description:
                "아메리카는 브라우저용 로드트립 시뮬레이터입니다: 지도, 라디오, 사진, 데스크톱 스타일 인터페이스로 미국 자연의 경이를 자신만의 속도로 탐색. 다운로드 불필요; 온라인으로 여행을 시작하세요.",
            jsonld_genre: ["로드트립 시뮬레이터", "탐험 게임", "브라우저 게임"],
            page_title: "아메리카: 로드트립 시뮬레이터 | 브라우저에서 미국 탐색",
            html_lang: "ko",
            og_locale: "ko_KR",
            og_locale_alternate: ["en_US", "es_ES", "fr_FR", "de_DE", "ru_RU", "ja_JP", "zh_CN", "pt_BR"],
            og_image_alt: "로드트립 시뮬레이터 아메리카 스크린샷",
            twitter_image_alt: "로드트립 시뮬레이터 아메리카 스크린샷",
        },
    }
};
